import { bookDescriptionHtml } from "../../helpers/bookDescription";
import "../../styles/BookDescription.css";

export default function BookDescription({ description, className = "" }) {
  const html = bookDescriptionHtml(description);

  if (!html) return null;

  return (
    <div
      className={["book-description", className].filter(Boolean).join(" ")}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
